import React from 'react';
import { useState } from 'react';
import Spinner from './Spinner';
import { useDispatch } from "react-redux";
import { FaCloudUploadAlt, MdDelete } from '../assets/icons';
import { deleteObject, getDownloadURL, ref, uploadBytesResumable } from 'firebase/storage';
import { storage } from '../config/firebase.config';
import { alertDanger, alertNULL, alertSuccess } from '../context/actions/alertActions';
import { motion } from "framer-motion";
import { buttonClick } from '../animations';
import { useEffect } from 'react';
import { addNewProduct, getAllCategories, getAllProducts } from '../api';
import { setAllProducts } from '../context/actions/productAction';

const DBNewItem = () => {
    const dispatch = useDispatch();
    const [itemName, setItemName] = useState("");
    const [category, setCategory] = useState(null);
    const [price, setPrice] = useState("")
    const [isLoading, setIsLoading] = useState(false);
    const [imageDownloadUrl, setImageDownloadUrl] = useState(null);
    const [progress, setProgress] = useState(null);
    const [isFormReady, setIsFormReady] = useState(false); // Step 1
    const [statuses, setStatuses] = useState([])

    useEffect(() => {
        getAllCategories()
            .then((categories) => {
                setStatuses(categories.data);
            })
            .catch((error) => {
                console.error(error);
            });
    }, []);

    const uploadImage = (e) => {
        setIsLoading(true);
        const imageFile = e.target.files[0];
        const storageRef = ref(storage, `Images/${Date.now()}_${imageFile.name}`);
        const uploadTask = uploadBytesResumable(storageRef, imageFile);
        uploadTask.on('state_changed', (snapshot) => {
            setProgress((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
        }, (error) => {
            dispatch(alertDanger(`Error : ${error}`))
            setTimeout(() => {
                dispatch(alertNULL())
            }, 3000);
        }
            , () => {
                getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                    setImageDownloadUrl(downloadURL);
                    setIsLoading(false);
                    setProgress(null);
                    dispatch(alertSuccess("Image uploaded to the cloud "));
                    setTimeout(() => {
                        dispatch(alertNULL())
                    }, 3000);
                })
            })
    };
    const deleteImageFromFireBase = () => {
        setIsLoading(true);
        const deleteRef = ref(storage, imageDownloadUrl)
        deleteObject(deleteRef).then(() => {
            setImageDownloadUrl(null)
            dispatch(alertSuccess("Image removed from the cloud"));
            setIsLoading(false);
            setTimeout(() => {
                dispatch(alertNULL());
            }, 3000);
        })
    };

    const submitNewData = () => {
        const data = {
            product_name: itemName,
            product_category: category,
            product_price: price,
            imageURL: imageDownloadUrl,
        }
        addNewProduct(data).then(res => {
            dispatch(alertSuccess("new Item Added"))
            setTimeout(() => {
                dispatch(alertNULL());
            }, 3000);
            setImageDownloadUrl(null);
            setItemName("")
            setPrice("")
            setCategory(null)
            setIsLoading(false)
        });
        getAllProducts().then((data) => {
            dispatch(setAllProducts(data));
        });
    }
    useEffect(() => {
        // Check if all required fields are filled in
        if (itemName && category && price && imageDownloadUrl) {
            setIsFormReady(true);
        } else {
            setIsFormReady(false);
        }
    }, [itemName, category, price, imageDownloadUrl]);


    return (
        <div className='flex items-center justify-center flex-col pt-6 px-24 w-full'>
            <div className='border border-gray-300 rounded-md p-4 w-full flex flex-col items-center justify-center gap-4'>
                <InputValueField
                    type="text"
                    placeHolder={"Nhập tên sản phẩm"}
                    stateFunc={setItemName}
                    stateValue={itemName}
                />
                <div className='w-full flex items-center justify-around gap-3 flex-wrap'>
                    {statuses && statuses?.map((data,i) => (
                        <p key={`Cateogry_${i}`} className={`px-4 py-3 rounded-md text-md  font-semibold cursor-pointer hover:shadow-md border border-gray-200 backdrop-blur-md ${data.name === category ? "bg-red-400 text-primary" : "bg-transparent text-textColor"}`}
                            onClick={() => setCategory(data.name)}
                        >
                            {data.name}
                        </p>
                    ))}
                </div>
                <InputValueField
                    type="number"
                    placeHolder={"Nhập giá sản phẩm"}
                    stateFunc={setPrice}
                    stateValue={price}
                />
                <div className='w-full bg-card backdrop-blur-md h-370 rounded-md border-2 border-dotted border-gray-300 cursor-pointer'>
                    {isLoading ? <div className='w-full h-full flex flex-col items-center justify-evenly px-24'>
                        <Spinner />
                        <div class="w-full bg-gray-200 rounded-full dark:bg-gray-700">
                            <div class="bg-blue-600 text-xs font-medium text-blue-100 text-center p-0.5 leading-none rounded-full" style={{ width: `${progress}%` }}>
                                {Math.floor(progress)}%
                            </div>

                        </div>
                    </div> : (<>
                        {!imageDownloadUrl ? <>
                            <label>
                                <div className='flex flex-col items-center justify-center h-full w-full cursor-pointer'>
                                    <p className='font-bold text-4xl'>
                                        <FaCloudUploadAlt className="-rotate-0" />
                                    </p>
                                    <p className='text-lg text-textColor'>
                                        Đăng tải hình ảnh
                                    </p>
                                </div>
                                <input type="file"
                                    name="upload-image"
                                    accept="image/*"
                                    onChange={uploadImage}
                                    className='w-0 h-0'
                                />
                            </label>
                        </> : <>
                            <div className='relative w-full h-full overflow-hidden rounded-md'>
                                <motion.img
                                    whileHover={{ scale: 1.15 }}
                                    src={imageDownloadUrl}
                                    className="w-full h-full object-cover"
                                />
                                <motion.button
                                    {...buttonClick}
                                    type='button'
                                    className='absolute top-3 right-3 p-3 rounded-full bg-red-500 text-xl cursor-pointer outline-none hover:shadow-md hover:text-white duration-500 transition-all ease-in-out'
                                    onClick={() => deleteImageFromFireBase(imageDownloadUrl)}
                                >
                                    <MdDelete className='' />
                                </motion.button>
                            </div>
                        </>}
                    </>)}
                </div>
                <motion.button
                    onClick={submitNewData}
                    {...buttonClick}
                    className={`w-9/12 py-3 rounded-md bg-red-400 text-primary hover:bg-red-500 cursor-pointer ${!isFormReady || isLoading ? 'opacity-50 cursor-not-allowed' : ''}`} // Step 2
                    disabled={!isFormReady || isLoading} // Step 3
                >
                    Tạo sản phẩm
                </motion.button>
            </div>

        </div>
    )
}

export const InputValueField = ({ type, placeHolder, stateValue, stateFunc }) => {
    return <>
        <input type={type}
            placeholder={placeHolder}
            className='w-full px-4 py-3 bg-lightOverlay shadow-md outline-none rounded-md border border-gray-200 forcus:border-red-400'
            value={stateValue}
            onChange={(e) => stateFunc(e.target.value)}
        />
    </>;
}

export default DBNewItem